import script from "./ResponsibleUsersTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponsibleUsersTable.vue?vue&type=script&setup=true&lang=js"

import "./ResponsibleUsersTable.vue?vue&type=style&index=0&id=35672e6a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35672e6a"]])

export default __exports__